import SettingsMain from "../components/settings/SettingsMain"

const SettingsPage = () => {
  return (
    <SettingsMain />
  )
}
export default SettingsPage